import { render, staticRenderFns } from "./JoszakiUpload.vue?vue&type=template&id=4eb44c85"
import script from "./JoszakiUpload.vue?vue&type=script&lang=js"
export * from "./JoszakiUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports